exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-backdrop {\n  opacity: 0.5;\n}\n.modal-footer {\n  display: none;\n}", ""]);

// exports
